/****
 * 這是对OSS相關方法的封裝
 **/

import ccVueUtils from 'cc-vue-utils'

var _config = {
    getAuthorizationURL: "admin/fsb/file/aliyun/uploadToken",
    bucket: "fosber-pri", // cos buket
    bucketType: "private",
    // endpoint: "oss-cn-shenzhen.aliyuncs.com",
    endpoint: "oss-cn-shenzhen.aliyuncs.com",
    myFolder: "/", // cos folder
    privateDownloadUrlApi: "admin/fsb/file/aliyun/privateDownloadUrl"
}

var _configPublish = {
    getAuthorizationURL: "admin/fsb/file/aliyun/uploadToken",
    bucket: "fosber-pri", // cos buket
    bucketType: "public",
    endpoint: "oss-cn-shenzhen.aliyuncs.com",
    myFolder: "/pic/", // cos folder
    fileType: 'image'
}

/***
 * 获取私有桶的下载地址
 *  */
function _getPrivateDownloadUrl(url) {

    return new Promise(function (resolve, reject) {
        let d = {
            url: url
        }
        ccVueUtils.ccRequest
            .do(_config.privateDownloadUrlApi, d)
            .then((res) => {
                resolve(res.url)
            }).catch((err) => {
                reject(err)
            })
    })

}



export default {
    config: _config,
    configPublish: _configPublish,
    getPrivateDownloadUrl: _getPrivateDownloadUrl
}


